import Icon from '@mdi/react';
import {mdiInformationOutline} from '@mdi/js';

const InformationBanner = () => {
    return (
        <div className="alert alert-warning" role="alert">
            <p className="alert-heading">
                <Icon path={mdiInformationOutline} className="mdi mr-2"/>
                Dessa ändringar skickas till handläggare som ändrar uppgifterna manuellt.
            </p>
        </div>
    );
};

export default InformationBanner;
